import { useQuery } from "@tanstack/react-query";
import { onboardingApi } from "./api";

export const useOnboardingQuestions = () => {
  return useQuery({
    queryKey: ["onboarding", "questions"],
    queryFn: onboardingApi.getQuestions,
    retry: false,
  });
};
